import { useAppDispatch } from "@/app/_redux/store";
import {
  changeSelectedOrderStatus,
//   selectUI,
} from "@/app/_redux/slice/UISlice/UISlice";
import {
  getSchedules,
  order,
  scheduleModel,
} from "@/app/_redux/slice/Order/OrderSlice";
import { useSelector } from "react-redux";
import { useState, useCallback } from "react";
import CustomModalClients from "../global/modal/CustomModalWithoutWhite";

interface DeliveryType {
  id: number;
  name: string;
  value: "DELIVERY" | "PICKUP";
}

const DELIVERY_TYPE: DeliveryType[] = [
  { id: 1, name: "Delivery", value: "DELIVERY" },
  { id: 2, name: "PickUp", value: "PICKUP" },
];

export default function OrderTypeModal({ open, handleClose }: {open: boolean, handleClose: () => void}) {
  const dispatch = useAppDispatch();
//   const { selectedOrderStatus } = useSelector(selectUI);
  const { schedule } = useSelector(order);

  const [selected, setSelected] = useState<"DELIVERY" | "PICKUP" | null>(null);

  const handleSelection = useCallback(
    (value: "DELIVERY" | "PICKUP") => {
      setSelected(value);
      localStorage.setItem("selectedOrderStatus", value);
      dispatch(changeSelectedOrderStatus(value));

      if (schedule?.orderType !== value && schedule !== null) {
        dispatch(getSchedules(null));
        dispatch(scheduleModel(true));
      }

      setTimeout(() => {
        handleClose?.();
      }, 200);
    },
    [dispatch, schedule, handleClose]
  );

  return (
    <CustomModalClients
      open={open}
      className="w-full max-w-md rounded-2xl shadow-xl bg-white"
    >
      <div className="p-8 flex flex-col items-center gap-4">
  <div className="flex gap-4">
    {DELIVERY_TYPE.map((type) => {
      const isActive = selected === type.value;
      return (
        <button
          key={type.id}
          onClick={() => handleSelection(type.value)}
          className={`px-6 py-3 rounded-md font-medium transition-all duration-200 border 
            ${
              isActive
                ? "bg-black text-white border-black"
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
            }`}
        >
          {type.name}
        </button>
      );
    })}
  </div>

  {/* Note below buttons */}
  <p className="text-sm text-gray-500 mt-2">
    Please select one of the order types to continue.
  </p>
</div>
    </CustomModalClients>
  );
}
